var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-avatar',{staticClass:"default-icon-letter",staticStyle:{"color":"#f56a00","background-color":"#fde3cf"},attrs:{"size":_vm.size},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.firsLetter))])
}
var staticRenderFns = []

export { render, staticRenderFns }